import React from 'react';
import Loadable from 'react-loadable';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('../blank_offer_page').default;
}

export default function(store) {
  const routeConfig = {
    path:
      '/(international|students|students-international|digital|giveagift|redeem|studentsubscription|subscribetoday|gift|holidaysale|employeegift)',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "offerPage" */ '../blank_offer_page').then(
        resp => {
          Component = resp.default;
          // routeConfig.loadData = () => {};
          return Component;
        }
      );
    },
    chunk: 'offerPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="offer-page">
          <article className="offer-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
